import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import ActivityLog from 'models/activity_log';
import GoogleAnalytics from 'core/google_analytics';


/* An activity is a line item, with a checkbox and a star.
     The checkbox represents an activitylog, the star is a mood booster
     If the activity is custom, it will also have a (hidden) textarea for
     editing along with an edit/save button.
   */
export default Backbone.View.extend({
  events: {
    'click .check-activity': 'toggle_activity_log',
    'click .tracking-close-delete': 'remove_activity',
    'click .edit-custom-activity': 'edit_custom_activity',
    'click .cancel-edit-custom-activity': 'cancel_edit_custom_activity',
  },

  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    // Elements
    this.setElement(this.$el);
    this.date_nav = options.date_nav;

    this.editing = false;
    this.updating = false;
    // Rerender when the date changes
    this.date_nav.on('change', this.render_async);
    this.parent_view = options.parent_view;
    this.activities_view = options.activities_view;
    this.activityLogs = this.parent_view.activity_log_collection;
    this.activity_collection = this.parent_view.activity_collection;
    this.mood_booster_collection = this.parent_view.mood_booster_collection;

    this.model.on('change', this.render_async);
  },

  setElement: function (el) {
    this.check_activity = el.find('.check-activity');

    // Keep track of checked state to avoid DOM lookups
    this.checked = this.check_activity.hasClass('activity-checked');

    Backbone.View.prototype.setElement.call(this, el);
  },

  finishUpdate: function () {
    this.updating = false;
  },

  toggle_activity_log: function (e) {
    e.preventDefault();
    if (this.updating) {
      return;
    }
    this.updating = true;
    var activity_log = this.get_activity_log();
    this.toggle_class('checked', !activity_log, this.check_activity, 'activity-checked');
    if (activity_log) {
      activity_log.destroy();
    } else {
      var newActivityLog = new ActivityLog({
        activity: this.model.get('resource_uri'),
        date: this.date
      });
      newActivityLog.on('sync', this.finishUpdate);
      this.activityLogs.create(newActivityLog);
      var domain = this.model.get_group(this.parent_view.activity_group_collection).get('name');
      GoogleAnalytics.send_event('Activities', 'logged', domain, 1);
    }
  },

  edit_custom_activity: function (e) {
    if (!this.editing) {
      this.go_to_edit_mode();
    } else {
      // Check that the field isn't blank
      if (!this.textarea.val()) {
        this.error_msg.html('The activity name cannot be blank<br/>');
        this.error_msg.removeClass('hidden');
        return;
      }
      // If the activity hasn't changed, just cancel editing
      if (this.model.get('name') === this.textarea.val()) {
        this.cancel_edit_custom_activity();
        return;
      }
      // Check that no other activity exists with this name
      var duplicate = this.activity_collection.findWhere({
        name: this.textarea.val()
      });
      if (duplicate) {
        this.error_msg.html('An activity with that name already exists<br/>');
        this.error_msg.removeClass('hidden');
        return;
      }
      // No problems, save the activity and close the edit form
      var value = this.textarea.val();
      this.model.save({ name: value, present_tense: value },
        { wait: true, success: $.proxy(function () {
          this.model.fetch();
          this.cancel_edit_custom_activity();
        }, this) });
    }
  },

  go_to_edit_mode: function () {
    this.editing = true;
    this.edit_button.val('Save');
    this.cancel_button.removeClass('hidden');
    this.activity_name.hide();
    this.textarea.show();
  },

  cancel_edit_custom_activity: function () {
    this.editing = false;
    this.edit_button.val('Edit');
    this.error_msg.addClass('hidden');
    this.cancel_button.addClass('hidden');
    this.textarea.hide();
    this.textarea.val(this.activity_name.html());
    this.activity_name.show();
  },

  remove_activity: function (e) {
    e.preventDefault();

    // Delete activity log
    var activity_log = this.get_activity_log();
    if (activity_log) {
      activity_log.destroy();
    }

    if (this.activities_view.type == 'today') {
      // Delete custom activity
      this.model.destroy();
    }
  },

  render_async: function () {
    setTimeout(this.render, 0);
  },

  render: function () {
    this.date = this.date_nav.formatted_date();
    this.activity_name = $('.activity-name', this.$el);
    this.textarea = $('textarea', this.$el);
    this.edit_button = $('.edit-custom-activity', this.$el);
    this.cancel_button = $('.cancel-edit-custom-activity', this.$el);
    this.error_msg = $('.text-error', this.$el);

    // Only run this block on the first render
    if (typeof this.textarea_val === 'undefined') {
      this.textarea_val = this.activity_name.html();
      this.textarea.val(this.textarea_val);
      this.textarea.autoResize({ textlimit: 64 });
      this.textarea.keypress($.proxy(function () {
        this.textarea_val = this.textarea.val();
      }, this));
    } else {
      this.textarea.val(this.textarea_val);
    }

    if (this.editing) {
      this.go_to_edit_mode();
    } else {
      this.textarea.hide();
    }

    if (this.model.get('name') !== this.textarea_val) {
      this.textarea_val = this.model.escape('name');
      this.activity_name.html(this.textarea_val);
      this.textarea.val(this.textarea_val);
    }

    // Activity Log: Check or uncheck
    this.toggle_class('checked', this.get_activity_log(), this.check_activity, 'activity-checked');
    return this;
  },

  get_activity_log: function () {
    return this.activityLogs.findWhere({
      date: this.date,
      activity: this.model.get('resource_uri')
    });
  },

  toggle_class: function (prop, c2, el, css_class) {
    // If the check is already correct, just return
    if (this[prop] && c2 || !(this[prop] || c2)) {
      return;
    }
    // Add or remove the necessary class
    if (c2) {
      el.addClass(css_class);
    } else {
      el.removeClass(css_class);
    }
    this[prop] = Boolean(c2);
  }
});



// WEBPACK FOOTER //
// ./static/js/views/activity.js